import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_post_import = _resolveComponent("create-post-import")!
  const _component_reconnect_btn = _resolveComponent("reconnect-btn")!
  const _component_connect_account = _resolveComponent("connect-account")!
  const _component_request_support = _resolveComponent("request-support")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: `Import ${_ctx.platform.name} Posts`,
    size: "md",
    "body-style": {padding: 0},
    ref: "modal"
  }, {
    default: _withCtx(() => [
      (_ctx.platform.auth === null)
        ? (_openBlock(), _createBlock(_component_create_post_import, {
            key: 0,
            platform: _ctx.platform,
            "get-account-id": _ctx.accountIdProvider,
            onCreated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hide()))
          }, null, 8, ["platform", "get-account-id"]))
        : (_openBlock(), _createBlock(_component_connect_account, {
            key: 1,
            platform: _ctx.platform
          }, {
            default: _withCtx(() => [
              _createVNode(_component_reconnect_btn, {
                account: _ctx.account,
                color: "primary",
                "icon-right": "fa fa-arrow-right",
                label: "Get Started",
                rounded: "",
                onReconnected: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hide()))
              }, null, 8, ["account"])
            ]),
            _: 1
          }, 8, ["platform"])),
      _createVNode(_component_request_support, {
        platform: _ctx.platform.name,
        "get-account-id": _ctx.accountIdProvider
      }, null, 8, ["platform", "get-account-id"])
    ]),
    _: 1
  }, 8, ["title"]))
}